import ServiceHero from "../../../components/elements/service-hero";
import FeatureStrip from "../../../components/elements/feature-strip";
import { PricingCardFlex } from "../../../components/elements/pricing-card";
import SectionTitle from "../../../components/elements/section-title";
import CTA from "../../../components/elements/CTA";
import "../ep-courses-and-services-pages.css";

export default function RedacaoEnem() {
  const features = [
    ["▤", "Estrutura textual"],
    ["☼", "Argumentação e repertório"],
    ["♧", "Coesão e coerência"],
    ["▥", "Simulados e acompanhamento"],
    ["☏", "Feedback personalizado"],
  ];

  const steps = [
    ["01", "Entenda", "Conheça a proposta e os critérios relevantes."],
    ["02", "Pratique", "Produza textos com orientação."],
    ["03", "Receba feedback", "Entenda seus pontos fortes e o que melhorar."],
    ["04", "Evolua", "Aplique as orientações nas próximas produções."],
  ];

  return (
    <>
      {/* <ServicePageLayout
      eyebrow="Redação ENEM"
      title="Prepare sua redação para o ENEM com estratégia e prática."
      description="Aprenda a organizar suas ideias, desenvolver argumentos e construir uma redação consistente com acompanhamento individual e feedback."
     icon="ENEM" > */}

      {/* <SectionTitle
        eyebrow="Escrita & Prática"
        title="Um caminho claro para sua evolução"
        subtitle="Aprenda a organizar suas ideias, desenvolver argumentos e construir uma redação consistente com acompanhamento individual e feedback."
      /> */}

      <ServiceHero
        eyebrow="REDAÇÃO ENEM"
        title={
          <>
            Prepare sua redação para o ENEM e alcance seus <em>objetivos.</em>
          </>
        }
        description="Desenvolva suas habilidades de escrita, aprenda técnicas e conquiste uma redação com alto desempenho no ENEM."
        image="/images/redacao-enem-plano.png"
        // quote="Mais do que uma nota, é o seu futuro!"
      />

      <main>
        <div className="container service-body">
          <FeatureStrip
            items={features.map(([icon, label]) => ({ icon, label }))}
          />
          <div className="two-col" id="como-funciona">
            <section className="paper-panel">
              <SectionTitle title="O que você vai desenvolver?" />
              <ul className="check-list">
                <li>Domínio das competências do ENEM</li>
                <li>Estrutura e organização do texto</li>
                <li>Argumentação sólida e repertório sociocultural</li>
                <li>Coesão e coerência textual</li>
                <li>Estratégias para a prova</li>
                <li>Simulados e correções com feedback</li>
              </ul>
              {/* <p className="hand-note">
                Seu esforço de hoje é o resultado de amanhã!
              </p> */}
            </section>
            <section className="paper-panel">
              <SectionTitle title="Nossos planos" />
              <div className="mentoring-pricing-list">
                <PricingCardFlex
                  title="Correçao Avulsa"
                  tag="1 redações"
                  price="14,90"
                  unit="/ redação"
                  features={[
                    "Avaliação das 5 competências",
                    "Principais ajuste e erros",
                    "Nota final",
                    "Áudio de 3 minutos",
                  ]}
                />
                <PricingCardFlex
                  title="Plano Mensal Intermediário"
                  tag="4 redações"
                  price="49,90"
                  unit="/mês"
                  features={[
                    "Avaliação das 5 competências",
                    "Principais ajuste e erros",
                    "Nota final",
                    "Áudio de 4 minutos",
                  ]}
                />
                <PricingCardFlex
                  title="Plano Mensal Completo"
                  tag="8 redações"
                  price="89,90"
                  unit="/mês"
                  features={[
                    "Avaliação das 5 competências",
                    "Principais ajuste e erros",
                    "Nota final",
                    "Áudio de 5 minutos",
                  ]}
                  featured
                />
              </div>
            </section>
          </div>

          <CTA
            title="Sua próxima redação "
            titleBr="pode ser a melhor que você já escreveu."
            subtitle="Dê o primeiro passo agora mesmo!"
            button="QUERO ME PREPARAR PARA O ENEM"
            href=""
          />

          {/* <div className="ep-service-steps">
            {steps.map(([number, stepTitle, text]) => (
              <div className="ep-service-step" key={number}>
                <div className="ep-service-step-number">{number}</div>
                <h3>{stepTitle}</h3>
                <p>{text}</p>
              </div>
            ))}{" "}
          </div> */}

          <section className="why">
            <SectionTitle
              align="center"
              title="Por que escolher o Escrita Prática?"
            />
            <div className="why-grid">
              {[
                "Acompanhamento personalizado",
                "Metodologia comprovada",
                "Foco em resultados reais",
                "Experiência e comprometimento",
                "Feedback construtivo e contínuo",
              ].map((x, i) => (
                <div key={i}>
                  <b>{["♧", "▤", "▥", "☆", "☏"][i]}</b>
                  <span>{x}</span>
                </div>
              ))}
            </div>
          </section>
        </div>
      </main>
    </>
  );
}
